import React, {FunctionComponent} from "react";
import {observer} from "mobx-react";
import {IconButton} from "@mui/material";
import {useStorageUserListContext} from "@app/modules/SelfConfig/contexts/storage";
import {useStorageContext} from "@app/contexts/storage";
import {MAIN_PAGE} from "@app/enums";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUserPlus} from "@fortawesome/free-solid-svg-icons";
import {runInAction} from "mobx";


interface IAddUserProps {
}


export const AddUser: FunctionComponent<IAddUserProps> = observer<FunctionComponent<IAddUserProps>>(function (props) {

    const {usersListStore} = useStorageUserListContext()
    const {globalStorage} = useStorageContext();


    return (
        <IconButton
            className={"featureButtons__i fa"}
            aria-hidden="true"
            title="Add user"
            onClick={() => {
                runInAction(() => {
                    usersListStore.addUser = !usersListStore.addUser
                    globalStorage.openModule = MAIN_PAGE.USER_CONFIG
                });
            }}
        >
            <FontAwesomeIcon icon={faUserPlus}/>
        </IconButton>
    )
});

